import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if user is logged in on mount
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/me`,
          {},
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
            withCredentials: true,
          }
        );
        if (response.data) {
          setUser(response.data);
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        // If auth check fails, clear token just in case
        if (error.response?.status === 401) {
          localStorage.removeItem("authToken");
        }
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  const login = (userData) => {
    if (userData.authToken) {
      localStorage.setItem("authToken", userData.authToken);
    }
    setUser(userData);
    setLoading(false);
  };
  const logout = () => {
    localStorage.removeItem("authToken");
    setUser(null);
    setLoading(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// ✅ PropTypes validation
AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAuth = () => useContext(AuthContext);
